import { render } from "./HelpStates-add.vue?vue&type=template&id=1f908a10"
import script from "./HelpStates-add.vue?vue&type=script&lang=js"
export * from "./HelpStates-add.vue?vue&type=script&lang=js"

import "./HelpStates-add.vue?vue&type=style&index=0&id=1f908a10&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__